// Generated by ReScript, PLEASE EDIT WITH CARE

import * as IdFunctor$FeedSync from "./IdFunctor.bs.mjs";

var include = IdFunctor$FeedSync.Make({});

var toString = include.toString;

var fromString = include.fromString;

var toJson = include.toJson;

var fromJson = include.fromJson;

var codec = include.codec;

var t_encode = include.t_encode;

var t_decode = include.t_decode;

export {
  toString ,
  fromString ,
  toJson ,
  fromJson ,
  codec ,
  t_encode ,
  t_decode ,
}
/* include Not a pure module */
